/* eslint-disable import/prefer-default-export */
export const isTokenValid = (token) => {
  const now = new Date();
  const secondsSinceEpoch = Math.round(now.getTime() / 1000);

  return token !== null && token.expires > secondsSinceEpoch;
};
